module.exports = __webpack_public_path__ + "img/Icons_Language.deb79bf6.png";